module.exports = "export default {tr:{ds:{modal:{ok:'Tamam',cancel:'İptal'}}}};"